import React from 'react'

import AbsolutePageTemplate from '../../../../components/templates/AbsolutePageTemplate'
import PageContent from '../_shared/PageContent'
import PageHeader from '../_shared/PageHeader'
import ServiceOrderLoader from '../_load/ServiceOrderLoader'
import ParentServiceOrderLoader from '../_load/ParentServiceOrderLoader'
import AssetsFieldValuesLoader from '../_load/AssetsFieldValuesLoader'

const TemplateVivoPdfPage = ({ id, templateId }) => {
  return (
    <AbsolutePageTemplate>
      <ServiceOrderLoader id={id}>
        <ParentServiceOrderLoader>
          <AssetsFieldValuesLoader>
            <PageHeader templateId={parseInt(templateId)} />
            <PageContent type={'VIVO'} templateId={parseInt(templateId)} />
          </AssetsFieldValuesLoader>
        </ParentServiceOrderLoader>
      </ServiceOrderLoader>
    </AbsolutePageTemplate>
  )
}

export default TemplateVivoPdfPage
